// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tutorial_ReportResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Tutorial_ReportRow } from './Tutorial_ReportRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Tutorial_ReportResponseDados = Tutorial_ReportRow[];

export type Tutorial_ReportResponse = ApiResponse<Tutorial_ReportResponseDados>;

registerResponseContract('Tutorial_ReportResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      slug:             { type: 'string',  required: true },
      total_users:      { type: 'string',  required: true },
      started:          { type: 'string',  required: true },
      completed:        { type: 'string',  required: true },
      skipped:          { type: 'string',  required: true },
      avg_step_reached: { type: 'string',  required: true },
      total_replays:    { type: 'string',  required: true },
    },
  },
})
